<template>
    <section class="detail_section">
        <v-form ref="form" v-model="valid">
            <v-row class="detail_wrapper">
                <v-col cols="12" class="success_header">
                    <div class="top_icon">
                        <svg height="100" :fill="preScoring.Scoring.color" viewBox="-4 0 511 511.99964" width="100" xmlns="http://www.w3.org/2000/svg"><path d="m498.429688 219.339844c-5.308594-8.015625-13.355469-13.539063-22.710938-15.632813 6.035156-11.542969 5.789062-25.945312-1.898438-37.550781-5.46875-8.261719-13.71875-13.597656-22.699218-15.617188 1.601562-3.054687 2.785156-6.351562 3.492187-9.828124 1.960938-9.667969.046875-19.519532-5.402343-27.742188-5.308594-8.019531-13.355469-13.542969-22.710938-15.632812 6.035156-11.542969 5.789062-25.945313-1.898438-37.554688-11.238281-16.972656-34.199218-21.640625-51.175781-10.398438l-36.757812 24.34375c-19.59375-9.9375-40.433594-16.988281-62.0625-21.003906-6.835938-10.378906-14.785157-20.027344-23.683594-28.652344l-15.207031-14.738281c-11.136719-10.796875-28.601563-12.417969-41.53125-3.851562-15.296875 10.128906-19.5 30.816406-9.371094 46.113281.398438.605469.789062 1.214844 1.175781 1.824219-49.847656 10.085937-95.277343 36.539062-128.902343 75.300781-36.488282 42.066406-56.585938 95.941406-56.585938 151.699219 0 10.6875.730469 21.394531 2.175781 31.816406 11.136719 81.019531 65.105469 150.839844 140.839844 182.21875 28.085937 11.640625 57.886719 17.546875 88.5625 17.546875 48.582031 0 95.085937-14.878906 134.488281-43.023438 38.546875-27.539062 67.386719-65.542968 83.40625-109.902343 1.496094-4.132813-.648437-8.699219-4.78125-10.191407-4.136718-1.492187-8.699218.648438-10.191406 4.785157-14.917969 41.308593-41.78125 76.699219-77.691406 102.351562-36.683594 26.207031-79.988282 40.058594-125.230469 40.058594-23.390625 0-46.230469-3.691406-68.089844-10.972656l64.773438-42.894531c.003906-.003907.007812-.003907.011719-.007813.003906 0 .003906-.003906.007812-.007813l53.832031-35.648437h.003907c4.832031-3.203125 8.132812-8.09375 9.289062-13.777344 1.15625-5.683593.03125-11.480469-3.171875-16.3125l-.710937-1.078125 10.457031-6.925781c7.460937-4.941406 16.433593-6.878906 25.269531-5.460937 12.792969 2.054687 25.785156-.757813 36.582031-7.910157l86.734375-57.4375c-.59375 7.523438-1.570312 15.003907-2.933594 22.359375-.804687 4.324219 2.050782 8.480469 6.375 9.28125.488282.09375.980469.136719 1.460938.136719 3.761719 0 7.105469-2.679687 7.816406-6.511719 2.207032-11.871094 3.476563-24.03125 3.804688-36.207031l24.441406-16.1875c8.222656-5.445313 13.835938-13.769531 15.796875-23.433594 1.964844-9.667969.046875-19.519531-5.398437-27.742187zm-177.21875-135.378906-24.324219 16.109374-4.789063-12.902343c-2-5.382813-4.292968-10.660157-6.832031-15.824219 12.339844 3.128906 24.355469 7.347656 35.945313 12.617188zm-252.097657 55.191406c32.316407-37.253906 76.335938-62.296875 124.492188-70.980469 7.726562 18.71875 9.578125 39.632813 4.960937 59.566406l-19.410156 83.855469c-3.050781-3.257812-7.011719-5.503906-11.472656-6.410156-5.6875-1.160156-11.480469-.03125-16.3125 3.171875l-54.980469 36.40625c-.003906 0-.003906 0-.007813.003906 0 0-.003906 0-.003906.003906l-79.296875 52.511719c-.433593-5.59375-.660156-11.230469-.660156-16.863281 0-51.921875 18.714844-102.09375 52.691406-141.265625zm207.191407 250.441406c-.308594 1.515625-1.191407 2.824219-2.484376 3.679688h.003907l-47.28125 31.308593-87.753907-130.871093c-2.449218-3.652344-7.394531-4.625-11.046874-2.175782-3.648438 2.449219-4.625 7.390625-2.175782 11.042969l87.699219 130.796875-67.496094 44.699219c-67.070312-29.335938-115.066406-91.289063-126.605469-163.378907l79.390626-52.402343 9.136718 13.632812c1.539063 2.289063 4.054688 3.527344 6.621094 3.527344 1.523438 0 3.066406-.433594 4.425781-1.347656 3.652344-2.449219 4.628907-7.394531 2.179688-11.046875l-9.074219-13.535156 48.320312-31.894532c1.285157-.855468 2.828126-1.152344 4.34375-.84375 1.515626.308594 2.824219 1.191406 3.679688 2.480469l107.273438 161.984375c.851562 1.285156 1.152343 2.828125.84375 4.34375zm211.921874-145.683594c-1.117187 5.5-4.308593 10.234375-8.988281 13.332032l-27.941406 18.503906c-.007813.003906-.015625.011718-.027344.015625l-99.730469 66.046875c-7.460937 4.941406-16.433593 6.882812-25.269531 5.460937-12.789062-2.050781-25.78125.757813-36.582031 7.910157l-10.457031 6.925781-87.859375-132.667969 22.710937-98.105469c5.847657-25.273437 2.765625-51.894531-8.375-75.085937-.101562-.242188-.210937-.476563-.335937-.707032-2.140625-4.382812-4.570313-8.636718-7.285156-12.738281-5.28125-7.976562-3.089844-18.761719 4.890624-24.046875 6.742188-4.464844 15.851563-3.621094 21.65625 2.007813l15.207032 14.742187c16.449218 15.949219 29.359375 35.730469 37.328125 57.207032l8.28125 22.308593c.015625.042969.03125.078125.046875.117188.019531.050781.042968.105469.0625.15625.058594.136719.113281.261719.171875.367187.160156.335938.335937.667969.546875.984375 2.429687 3.667969 7.367187 4.671875 11.03125 2.242188l84.910156-56.226563c9.65625-6.394531 22.714844-3.742187 29.109375 5.914063s3.742187 22.714843-5.914063 29.109375l-7.371093 4.882812s-.003907 0-.007813.003906l-16.441406 10.890626c-.023438.015624-.039062.03125-.0625.042968-.09375.066406-.183594.128906-.257812.191406-3.398438 2.496094-4.277344 7.242188-1.921876 10.796876 2.425782 3.667968 7.367188 4.671874 11.035157 2.242187l16.453125-10.898437c4.675781-3.089844 10.273437-4.179688 15.769531-3.0625 5.496094 1.117187 10.234375 4.308593 13.328125 8.988281 3.097656 4.675781 4.191406 10.28125 3.074219 15.777343-1.117188 5.5-4.308594 10.234376-8.988281 13.332032l-23.820313 15.777344c-3.667969 2.425781-4.671875 7.363281-2.242187 11.03125 1.53125 2.3125 4.0625 3.566406 6.644531 3.566406 1.507812 0 3.035156-.429688 4.386719-1.324219l3.6875-2.441406 12.757812-8.449219c9.660156-6.394531 22.714844-3.742188 29.109375 5.914062 6.394531 9.660157 3.742187 22.714844-5.914063 29.113282l-11.898437 7.878906c-.0625.039062-.125.082031-.1875.125l-11.734375 7.769531c-3.667969 2.425781-4.671875 7.367188-2.242188 11.035157 1.53125 2.3125 4.0625 3.566406 6.644532 3.566406 1.507812 0 3.035156-.429688 4.386718-1.324219l3.6875-2.441406s0-.003907.003907-.003907l12.757812-8.445312c4.675781-3.097656 10.277344-4.191406 15.777344-3.070312 5.5 1.113281 10.234375 4.308593 13.332031 8.984374 3.09375 4.675782 4.183594 10.28125 3.066406 15.777344zm0 0"/></svg>
                    </div>
                    <v-row class="d-flex justify-space-between">
                        <v-col cols=12 md=6>
                            <h1 class="header_title text-center text-md-left mt-5 mt-md-0" :style="{color: preScoring.Scoring.color}" v-html="headerTitle"></h1>
                            <p class="header_subtitle text-center text-md-left">{{preScoring.Scoring.description}}</p>
                        </v-col>
                        <v-col cols=12 md=5 class="d-flex flex-column">
                            <div class="d-flex justify-md-end justify-center align-center">
                                <v-checkbox class="mt-0 mb-2" :rules="[...ruleLegal]" v-model="temsActive" :color="preScoring.Scoring.color" v-if="!disable_buttons_success || disable_buttons_success==0">
                                        <template v-slot:label>
                                            <div>Acepto las <a :href="preScoring.Scoring.conditions" :style="{color:preScoring.Scoring.color}" target="_blank" @click.stop>Condiciones del servicio</a></div>
                                        </template>
                                </v-checkbox>
                            </div>
                            <div class="d-flex justify-md-end justify-center mt-2">
                                <v-btn v-if="!showIframe" @click="send" class="btn-send elevation-0" :disabled="!!disabled" :style="{backgroundColor: preScoring.Scoring.color}">Quiero ofertas</v-btn>
                                <v-btn v-if="showIframe && showIframe != 'helloteca-partners' && ((!disable_buttons_success || disable_buttons_success==0))" :disabled="!!disabled" @click="send" class="btn-send elevation-0" :style="{backgroundColor: preScoringWarnings.color}">{{preScoringWarnings.btn_label}}</v-btn>
                                <v-btn v-if="showIframe && showIframe != 'helloteca-partners' && (disable_buttons_success && disable_buttons_success==1)"  class="btn-send elevation-0" :style="{backgroundColor: preScoringWarnings.color}">{{preScoringWarnings.btn_label}}</v-btn>
                                <v-btn v-if="showIframe && showIframe == 'helloteca-partners'"  class="btn-send elevation-0" :style="{backgroundColor: preScoringWarnings.color}" @click="send">Terminar</v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" class="success_body d-flex justify-center align-center">
                    <v-row>
                        <v-col cols="12">
                            <h1 class="product_name_title">{{productTitle}}</h1>
                        </v-col>
                        <v-col cols="12">
                            <v-row>
                                <v-col cols=12 md=6 class="detail_block left d-flex align-center flex-column">
                                    <h2 :style="{color: preScoring.Scoring.color}" class="title_block">Hipoteca Tipo <strong>VARIABLE</strong></h2>
                                    <v-row>
                                        <v-col cols="md-6" class="miniblock d-flex align-center flex-column">
                                            <p class="t1">Interés variable</p>
                                            <p class="t2">Eur+{{ preScoring.Scoring.variable_interes }}%</p>
                                            <p class="t3">*Podría llegar a ser <strong>Eur+{{ preScoring.Scoring.variable_interes_max }}%</strong> según condiciones.</p>
                                        </v-col>
                                        <v-col cols="md-6" class="miniblock d-flex align-center flex-column">
                                            <p class="t1">Cuota mensual</p>
                                            <p class="t2"> {{ preScoring.Scoring.variable_cuota | currency}}</p>
                                            <p class="t3">*Podría llegar a <strong>{{ preScoring.Scoring.variable_cuota_max | currency}}</strong> según condiciones</p>
                                        </v-col>
                                        <v-col cols="12"><p class="text_footer_block">Importes calculados a {{ preScoring.Scoring['variable_años'] }} años sin comisiones</p></v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols=12 md=6 class="detail_block right d-flex align-center flex-column">
                                    <h2 :style="{color: preScoring.Scoring.color}" class="title_block">Hipoteca Tipo <strong>FIJO</strong></h2>
                                    <v-row>
                                        <v-col cols="md-6" class="miniblock d-flex align-center flex-column">
                                            <p class="t1">Interés fijo</p>
                                            <p class="t2">{{ preScoring.Scoring.fijo_interes }}%</p>
                                            <p class="t3">*Podría llegar a ser <strong>{{ preScoring.Scoring.fijo_interes_max }}%</strong> según condiciones.</p>
                                        </v-col>
                                        <v-col cols="md-6" class="miniblock d-flex align-center flex-column">
                                            <p class="t1">Cuota mensual</p>
                                            <p class="t2"> {{ preScoring.Scoring.fijo_cuota | currency}}</p>
                                            <p class="t3">*Podría llegar a <strong>{{ preScoring.Scoring.fijo_cuota_max | currency}}</strong> según condiciones</p>
                                        </v-col>
                                        <v-col cols="12"><p class="text_footer_block">Importes calculados a {{ preScoring.Scoring['fijo_años'] }} años sin comisiones</p></v-col>
                                    </v-row>
                                </v-col>
                            </v-row>

                        </v-col>
                    </v-row>
                </v-col>
                
                <v-col cols="12" class="footer_blocks">
                    <div class="block">
                        <p class="title">{{valueLable}}</p>
                        <p class="value">{{preScoring.Scoring.valor_compra | currency}}</p>
                    </div>
                    <div class="block">
                        <p class="title">{{savingsLabel}}</p>
                        <p class="value">{{preScoring.Scoring.dinero_aportado | currency}}</p>
                    </div>
                    <div class="block">
                        <p class="title">Gastos en tu comunidad aut.</p>
                        <p class="value">{{preScoring.Scoring.gastos_en_tu_ccaa | currency}}</p>
                    </div>
                    <div class="block">
                        <p class="title">Importe a Financiar</p>
                        <p class="value">{{preScoring.Scoring.importe_a_financiar | currency}}</p>
                    </div>
                    <div class="block">
                        <p class="title">% sobre el valor de compra</p>
                        <p class="value">{{preScoring.Scoring.porcentaje_a_financiar}}%</p>
                    </div>
                    <div class="block">
                        <p class="title">Plazo</p>
                        <p class="value">{{preScoring.Scoring.variable_años}} Años</p>
                    </div>
                </v-col>

                <v-row class="footer_info d-flex justify-space-between">
                    <v-col cols=12 md=6 class="footer_info_left" :style="{color: preScoring.Scoring.color}">
                        <h4 class="theme m-0">Consigue la mejor financiación con Helloteca.</h4>
                        <h4 class="theme m-0">Ahorrarás tiempo y dinero gracias a la experiencia de más de 15 años de nuestros profesionales.</h4>
                        <p style="color:#333" class="mt-3">Entra en tu zona privada y consigue una oferta personalizada a tu medida con las mejores condiciones del mercado.</p>
                    </v-col>
                    <v-col cols=12 md=5 class="d-flex flex-column" >
                        <div class="d-flex justify-md-end justify-center align-center" v-if="!disable_buttons_success || disable_buttons_success==0">
                            <v-checkbox class="mt-0 mb-2" :rules="[...ruleLegal]" v-model="temsActive" :color="preScoring.Scoring.color">
                                <template v-slot:label>
                                    <div>Acepto las <a :href="preScoring.Scoring.conditions" :style="{color:preScoring.Scoring.color}" target="_blank" @click.stop>Condiciones del servicio</a></div>
                                </template>
                            </v-checkbox>
                        </div>
                        <div class="d-flex justify-md-end justify-center">
                            <v-btn v-if="!showIframe" @click="send" class="btn-send elevation-0" :disabled="!!disabled" :style="{backgroundColor: preScoring.Scoring.color}">Quiero ofertas</v-btn>
                            <v-btn v-if="showIframe && showIframe != 'helloteca-partners' && (!disable_buttons_success || disable_buttons_success==0)" :disabled="!!disabled" @click="send" class="btn-send elevation-0" :style="{backgroundColor: preScoringWarnings.color}">{{preScoringWarnings.btn_label}}</v-btn>
                            <v-btn v-if="showIframe && showIframe != 'helloteca-partners' && disable_buttons_success==1"  class="btn-send elevation-0" :style="{backgroundColor: preScoringWarnings.color}">{{preScoringWarnings.btn_label}}</v-btn>
                            <v-btn v-if="showIframe && showIframe == 'helloteca-partners'"  class="btn-send elevation-0" :style="{backgroundColor: preScoringWarnings.color}" @click="send">Terminar</v-btn>
                        </div>
                        
                    </v-col>
                </v-row>                
            </v-row>
            <div>
                <v-btn @click="$router.push('view3')" depressed class="blue_button error mt-10 ">Atras</v-btn> 
            </div>
        </v-form>
    </section>
</template>

<script>
    import { mapState,mapActions,mapMutations } from 'vuex';
    import rulesMixin from '../../mixins/rulesMixin'
    export default {
        mixins: [rulesMixin],
        data() {
            return {
                valid: false,
                disabled:false
            }
        },
        computed: {
            ...mapState([
                'preScoring',
                'preScoringWarnings',
                'loading',
                'products',
                'deal_id',
                'sucessTerms',
                'showIframe',
                'disable_buttons_success'
            ]),
            headerTitle(){
                return `${this.preScoring.Scoring.result.replace('ENHORABUENA!' , 'ENHORABUENA!<br>')}`;
            },
            productTitle(){
                if(this.preScoring && this.preScoring.Vivienda && this.preScoring.Vivienda.tipo_vivienda){
                    let index = this.products.map(product => product.type).indexOf(this.preScoring.Vivienda.tipo_vivienda);
                    return (index >= 0) ? this.products[index].title : '';
                }else{
                    return '';
                }
            },
            valueLable(){
                let label = 'Valor de compra';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'mejorar':
                    case 'ampliacion':
                        label = 'Valor de tasación';
                        break;
                }
                return label;
            },
            savingsLabel(){
                let label = 'Dinero aportado';
                switch (this.preScoring.Vivienda.tipo_vivienda) {
                    case 'mejorar':
                    case 'ampliacion':
                        label = 'Capital';
                        break;
                }
                return label;
            },
            temsActive: {
                get() {
                    return this.sucessTerms;
                },
                set(value) {
                    this.SET_SUCCESS_TERMS(value);
                }
            },
        },
        methods: {
             ...mapActions([
                'callUrlFromResponse',
                'callUrlFromResponseNewApi'
            ]),
            ...mapMutations([
                'SET_SUCCESS_TERMS'
            ]),
            send(){
                if(this.$refs.form.validate()){
                    if(this.showIframe){
                        this.disabled=true;
                        this.callUrlFromResponseNewApi(this.preScoringWarnings.btn_link)
                        .then(response =>{
                                console.log('redirec');
                            if(this.showIframe == 'helloteca-partners')
                                window.parent.location.href = 'https://helloteca.cloudframework.app/app.html#https://helloteca-com.web.app/vapps/partners_realestate.html?reload=true';
                            else
                                window.parent.location.href = 'https://helloteca.cloudframework.app/app.html#https://helloteca-com.web.app/vapps/helloteca_users.html?dealId='+this.deal_id+'&reload=true';
                            
                        })
                    }else{
                        this.disabled=true;
                        this.callUrlFromResponse(this.preScoring.Scoring.actions[0].endpoint)
                        .then(response =>{
                        
                            window.location.href = (response.data.data.url_documentos);
                        
                    })
                    }
                        
                }
                
            }
        },  
    }
</script>

<style lang="scss" scoped>
    $gray: '#D8D8D8';
    
    .detail_section{
        display: flex;
        flex-flow: column;
        align-items: center;
        padding: 50px 30px;
        box-sizing: border-box;
    }
    .detail_wrapper{
        width: 100%;
        max-width: 1150px;
        display: flex;
        flex-flow: column nowrap;
        .btn-send{
            font-size: 1.3rem;
            font-weight: bold;
            color: #FFF;
            padding: 10px 40px;
            border-radius: 5px;
            text-transform: initial;
            letter-spacing: initial;
            min-height: 50px;
        }
        .success_header{
            border-top: 1px solid #CCC;
            border-bottom: 1px solid #CCC;
            position: relative;
            margin-top: 50px;
            padding-top: 40px;
            box-sizing: border-box;
            .header_title{
                font-size: 2.3rem;
                line-height: 2.7rem;
            }
            .header_subtitle{
                font-size: .8rem;
                line-height: 1.2rem;
                color: $gray;
                margin-top: 10px;
            }
            .top_icon{
                position: absolute;
                top: 0;
                left: 50%;
                transform: translate(-50%, -50%);
                background: #FFF;
                padding: 10px 30px;
            }
        }
        .success_body{
            margin: 20px 0 40px;
            .product_name_title{
                font-size: 1.2rem;
                color: #666;
                text-align: center;
            }
        }
        .detail_block{
            padding: 20px;
            box-sizing: border-box;
           
            &.right{
                border-left: 1px solid #CCC;
                @media (max-width: 690px) {
                    border-left: none;
                }
            }
            .title_block{
                font-size: 1.5rem;
                margin: 10px;
                font-weight: 300;
                strong{
                    font-weight: 700;
                }
            }
            .miniblock{
                .t1{
                    font-size: 1rem;
                    font-weight: bold;
                    color: $gray;
                    margin: 0;
                }
                .t2{
                    font-size: 2.4rem;
                    font-weight: bold;
                    color: $gray;
                    margin: 0;
                }
                .t3{
                    font-size: .7rem;
                    font-weight: 700;
                    color: $gray;
                    margin: 0;
                    text-align: center;
                    strong{
                        color: var(--helloteca-main);
                    }
                }
            }
            .text_footer_block{
                font-size: .7rem;
                // font-weight: 700;
                // color: var(--helloteca-main);
                margin: 0;
                text-align: center;
            }
        }
        .footer_blocks{
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 5px 0px;
            border-top: 1px solid #CCC;
            border-bottom: 1px solid #CCC;
            padding: 20px 0;
            @media (max-width: 690px) {
                display: flex;
                flex-flow: column nowrap;
            }
            .block{
                padding: 10px 15px;
                box-sizing: border-box;
                display: flex;
                flex-flow: row nowrap;
                font-family: 'montserrat';
                font-weight: bold;
                color: $gray;
                p{
                    font-size: .9rem !important;
                    line-height: 1.1rem !important;
                    margin: 0 !important;
                }
                .title{
                    margin-bottom: 15px;
                    width: 60%;
                }
                .value{
                    margin-bottom: 15px;
                    width: 40%;
                }
            }
        }
        .footer_info{
            padding-top: 30px;
            .footer_info_left{
                h4{
                    font-weight: 500;
                }
                p{
                    color: $gray !important;
                    font-size: 1em;
                }
            }
        }
    }

</style>